import React, { useState } from 'react';
import * as moment from 'moment';
import { convertToCSVFormat, generateRatio, getAverage } from '../../../utils';
import CardABversion from './CardABversion';
import FailedDeliveryReport from '../../MessageAnalytics/Components/FailedDeliveryReport';
import SpamReport from '../../MessageAnalytics/Components/SpamReport';
import {
  DeliveryRateIcon,
  OpenRateIcon,
  ClickThroughRateIcon,
  BounceRateIcon,
  DropRateIcon,
  SpamReportIcon,
} from '../../SVGs/Icons';

const EmailABversion = ({
  emailEvents,
  message,
  isLoadingData,
  startDate,
  isDataAvailable,
  setClickActivityVisibility,
  setOpenActivityVisibility,
  setDeliveryActivityVisibility,
  smartResendEmailEvents,
  isSmartResendAvailable,
}) => {
  const [isFailedDeliveryDrawerVisible, setFailedDeliveryDrawerVisibility] =
    useState(false);
  const [isSpamDrawerVisible, setSpamDrawerVisibility] = useState(false);
  const [data, setData] = useState([]);
  const [csvData, setCSVData] = useState([]);
  const [failedDeliveryReportTitle, setFailedDeliveryReportTitle] =
    useState('');

  const handleEmailBounceRateClick = () => {
    const dataVersionA = emailEvents.bounceEvents.map(bounce => ({
      ...bounce,
      time: moment.unix(bounce.time).format('MM-DD-YYYY hh:mm A'),
      contact: bounce.email,
    }));

    const dataVersionB = emailEvents.versionB.bounceEvents.map(bounce => ({
      ...bounce,
      time: moment.unix(bounce.time).format('MM-DD-YYYY hh:mm A'),
      contact: bounce.email,
    }));

    const data = [...dataVersionA, ...dataVersionB];

    setData(data);
    setCSVData(convertToCSVFormat(data));
    setFailedDeliveryDrawerVisibility(true);
    setFailedDeliveryReportTitle('Bounce');
  };

  const handleEmailDropRateClick = () => {
    const dataVersionA = emailEvents.droppedEvents.map(dropped => ({
      ...dropped,
      time: moment.unix(dropped.time).format('MM-DD-YYYY hh:mm A'),
      contact: dropped.email,
    }));

    const dataVersionB = emailEvents.versionB.droppedEvents.map(dropped => ({
      ...dropped,
      time: moment.unix(dropped.time).format('MM-DD-YYYY hh:mm A'),
      contact: dropped.email,
    }));

    const data = [...dataVersionA, ...dataVersionB];

    setData(data);
    setCSVData(convertToCSVFormat(data));
    setFailedDeliveryDrawerVisibility(true);
    setFailedDeliveryReportTitle('Dropped Emails');
  };

  const handleSpamRateClick = () => {
    const dataVersionA = emailEvents.spamEvents.map(bounce => ({
      ...bounce,
      time: moment.unix(bounce.time).format('MM-DD-YYYY hh:mm A'),
      contact: bounce.email,
    }));

    const dataVersionB = emailEvents.versionB.spamEvents.map(bounce => ({
      ...bounce,
      time: moment.unix(bounce.time).format('MM-DD-YYYY hh:mm A'),
      contact: bounce.email,
    }));
    const data = [...dataVersionA, ...dataVersionB];

    setData(data);
    setCSVData(convertToCSVFormat(data));
    setSpamDrawerVisibility(true);
  };

  const showClickActivity = () => {
    setClickActivityVisibility(true);
  };

  const calcSmartResendClickThroughRateForVersionA = () => {
    const oldRatio = generateRatio(
      emailEvents.uniqueclick,
      emailEvents.uniqueopen
    );

    const newRatio = generateRatio(
      emailEvents.uniqueclick + smartResendEmailEvents.emailEventsA.uniqueclick,
      emailEvents.uniqueopen + smartResendEmailEvents.emailEventsA.uniqueopen
    );

    return parseInt(newRatio) - parseInt(oldRatio) + '%';
  };

  const calcSmartResendClickThroughRateForVersionB = () => {
    const oldRatio = generateRatio(
      emailEvents.versionB.uniqueclick,
      emailEvents.versionB.uniqueopen
    );

    const newRatio = generateRatio(
      emailEvents.versionB.uniqueclick +
        smartResendEmailEvents.emailEventsB.uniqueclick,
      emailEvents.versionB.uniqueopen +
        smartResendEmailEvents.emailEventsB.uniqueopen
    );

    return parseInt(newRatio) - parseInt(oldRatio) + '%';
  };

  const handleOpenRateClick = () => {
    setOpenActivityVisibility(true);
  };

  const handleDeliveryRateClick = () => {
    setDeliveryActivityVisibility(true);
  };

  return (
    <>
      <CardABversion
        name="Delivery Rate Average"
        valueARatio={generateRatio(emailEvents.delivered, emailEvents.sent)}
        valueBRatio={generateRatio(
          emailEvents.versionB.delivered,
          emailEvents.versionB.sent
        )}
        valueACount={emailEvents.delivered}
        valueBCount={emailEvents.versionB.delivered}
        smartResendValueARatio={
          smartResendEmailEvents?.emailEventsA
            ? generateRatio(
                smartResendEmailEvents.emailEventsA.delivered,
                smartResendEmailEvents.emailEventsA.sent
              )
            : null
        }
        smartResendValueBRatio={
          smartResendEmailEvents?.emailEventsB
            ? generateRatio(
                smartResendEmailEvents.emailEventsB.delivered,
                smartResendEmailEvents.emailEventsB.sent
              )
            : null
        }
        smartResendAverageCount={
          smartResendEmailEvents?.emailEventsA
            ? getAverage(
                smartResendEmailEvents.emailEventsA.delivered,
                smartResendEmailEvents.emailEventsB.delivered
              )
            : null
        }
        title="Contacts who were successfully delivered to."
        onClick={setDeliveryActivityVisibility ? handleDeliveryRateClick : null}
        isDataAvailable={isDataAvailable}
        isSmartResendAvailable={isSmartResendAvailable}
        messageStatus={message?.status}
        Icon={DeliveryRateIcon}
      />
      <CardABversion
        name="Open Rate Average"
        valueARatio={generateRatio(
          emailEvents.uniqueopen +
            (smartResendEmailEvents?.emailEventsA?.uniqueopen || 0),
          emailEvents.delivered
        )}
        valueBRatio={generateRatio(
          emailEvents.versionB.uniqueopen +
            (smartResendEmailEvents?.emailEventsB?.uniqueopen || 0),
          emailEvents.versionB.delivered
        )}
        valueACount={emailEvents.uniqueopen}
        valueBCount={emailEvents.versionB.uniqueopen}
        smartResendValueARatio={
          smartResendEmailEvents?.emailEventsA
            ? generateRatio(
                smartResendEmailEvents.emailEventsA.uniqueopen,
                emailEvents.delivered
              )
            : null
        }
        smartResendValueBRatio={
          smartResendEmailEvents?.emailEventsB
            ? generateRatio(
                smartResendEmailEvents.emailEventsB.uniqueopen,
                emailEvents.versionB.delivered
              )
            : null
        }
        smartResendAverageCount={
          smartResendEmailEvents?.emailEventsA
            ? getAverage(
                smartResendEmailEvents.emailEventsA.uniqueopen,
                smartResendEmailEvents.emailEventsB.uniqueopen
              )
            : null
        }
        title="The number of contacts who opened your email at least
        once. (It's a great indicator of subject line quality.)"
        onClick={setOpenActivityVisibility ? handleOpenRateClick : null}
        isDataAvailable={isDataAvailable}
        isSmartResendAvailable={isSmartResendAvailable}
        showComparativeAnalytics
        messageStatus={message?.status}
        Icon={OpenRateIcon}
      />
      <CardABversion
        name="Click-Through Rate Average"
        valueARatio={generateRatio(
          emailEvents.uniqueclick +
            (smartResendEmailEvents?.emailEventsA?.uniqueclick || 0),
          emailEvents.uniqueopen +
            (smartResendEmailEvents?.emailEventsA?.uniqueopen || 0)
        )}
        valueBRatio={generateRatio(
          emailEvents.versionB.uniqueclick +
            (smartResendEmailEvents?.emailEventsB?.uniqueclick || 0),
          emailEvents.versionB.uniqueopen +
            (smartResendEmailEvents?.emailEventsB?.uniqueopen || 0)
        )}
        valueACount={emailEvents.uniqueclick}
        valueBCount={emailEvents.versionB.uniqueclick}
        smartResendValueARatio={
          smartResendEmailEvents?.emailEventsA
            ? calcSmartResendClickThroughRateForVersionA()
            : null
        }
        smartResendValueBRatio={
          smartResendEmailEvents?.emailEventsB
            ? calcSmartResendClickThroughRateForVersionB()
            : null
        }
        smartResendAverageCount={
          smartResendEmailEvents?.emailEventsA
            ? getAverage(
                smartResendEmailEvents.emailEventsA.uniqueclick,
                smartResendEmailEvents.emailEventsB.uniqueclick
              )
            : null
        }
        title="The number of contacts who clicked a link in your email after opening it. (It's a great indicator of content quality.)"
        isDataAvailable={isDataAvailable}
        onClick={setClickActivityVisibility ? showClickActivity : null}
        isSmartResendAvailable={isSmartResendAvailable}
        showComparativeAnalytics
        messageStatus={message?.status}
        Icon={ClickThroughRateIcon}
      />
      <CardABversion
        name="Bounce Rate Average"
        valueARatio={generateRatio(emailEvents.bounce, emailEvents.sent)}
        valueBRatio={generateRatio(
          emailEvents.versionB.bounce,
          emailEvents.versionB.sent
        )}
        valueACount={emailEvents.bounce}
        valueBCount={emailEvents.versionB.bounce}
        smartResendValueARatio={
          smartResendEmailEvents?.emailEventsA
            ? generateRatio(
                smartResendEmailEvents.emailEventsA.bounce,
                smartResendEmailEvents.emailEventsA.sent
              )
            : null
        }
        smartResendValueBRatio={
          smartResendEmailEvents?.emailEventsB
            ? generateRatio(
                smartResendEmailEvents.emailEventsB.bounce,
                smartResendEmailEvents.emailEventsB.sent
              )
            : null
        }
        smartResendAverageCount={
          smartResendEmailEvents?.emailEventsA
            ? getAverage(
                smartResendEmailEvents.emailEventsA.bounce,
                smartResendEmailEvents.emailEventsB.bounce
              )
            : null
        }
        title="Usually a result of sending to a bad email address."
        onClick={handleEmailBounceRateClick}
        isDataAvailable={isDataAvailable}
        isSmartResendAvailable={isSmartResendAvailable}
        messageStatus={message?.status}
        Icon={BounceRateIcon}
      />
      <CardABversion
        name="Drop Rate Average"
        valueARatio={generateRatio(emailEvents.dropped, emailEvents.sent)}
        valueBRatio={generateRatio(
          emailEvents.versionB.dropped,
          emailEvents.versionB.sent
        )}
        valueACount={emailEvents.dropped}
        valueBCount={emailEvents.versionB.dropped}
        smartResendValueARatio={
          smartResendEmailEvents?.emailEventsA
            ? generateRatio(
                smartResendEmailEvents.emailEventsA.dropped,
                smartResendEmailEvents.emailEventsA.sent
              )
            : null
        }
        smartResendValueBRatio={
          smartResendEmailEvents?.emailEventsB
            ? generateRatio(
                smartResendEmailEvents.emailEventsB.dropped,
                smartResendEmailEvents.emailEventsB.sent
              )
            : null
        }
        smartResendAverageCount={
          smartResendEmailEvents?.emailEventsA
            ? getAverage(
                smartResendEmailEvents.emailEventsA.dropped,
                smartResendEmailEvents.emailEventsB.dropped
              )
            : null
        }
        title='"Dropped" means that an email was not sent because of an unresolved "Bounce" or "Spam Report" issue for that contact.'
        onClick={handleEmailDropRateClick}
        isDataAvailable={isDataAvailable}
        isSmartResendAvailable={isSmartResendAvailable}
        messageStatus={message?.status}
        Icon={DropRateIcon}
      />
      <CardABversion
        name="Spam Report Rate Average"
        valueARatio={generateRatio(emailEvents.spamReport, emailEvents.sent)}
        valueBRatio={generateRatio(
          emailEvents.versionB.spamReport,
          emailEvents.versionB.sent
        )}
        valueACount={emailEvents.spamReport}
        valueBCount={emailEvents.versionB.spamReport}
        smartResendValueARatio={
          smartResendEmailEvents?.emailEventsA
            ? generateRatio(
                smartResendEmailEvents.emailEventsA.spamReport,
                smartResendEmailEvents.emailEventsA.sent
              )
            : null
        }
        smartResendValueBRatio={
          smartResendEmailEvents?.emailEventsB
            ? generateRatio(
                smartResendEmailEvents.emailEventsB.spamReport,
                smartResendEmailEvents.emailEventsB.sent
              )
            : null
        }
        smartResendAverageCount={
          smartResendEmailEvents?.emailEventsA
            ? getAverage(
                smartResendEmailEvents.emailEventsA.spamReport,
                smartResendEmailEvents.emailEventsB.spamReport
              )
            : null
        }
        title="The number of contacts who reported your message as spam."
        onClick={handleSpamRateClick}
        isDataAvailable={isDataAvailable}
        isSmartResendAvailable={isSmartResendAvailable}
        messageStatus={message?.status}
        Icon={SpamReportIcon}
      />
      <FailedDeliveryReport
        onCloseDrawer={() => setFailedDeliveryDrawerVisibility(false)}
        isVisible={isFailedDeliveryDrawerVisible}
        isLoading={isLoadingData}
        message={message}
        startDate={startDate}
        data={data}
        csvData={csvData}
        title={failedDeliveryReportTitle}
      />
      <SpamReport
        onCloseDrawer={() => setSpamDrawerVisibility(false)}
        isVisible={isSpamDrawerVisible}
        isLoading={isLoadingData}
        message={message}
        startDate={startDate}
        data={data}
        csvData={csvData}
      />
    </>
  );
};

export default EmailABversion;
